import { DEFAULT_ADDITIONAL_OBJECTS_LIMIT, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import React from 'react'
import { AdditionalObjectRow } from './AdditionalObjectsRow'
import { DetailedCRMAccountIntegrationMapping, MappingType } from '../../../../../../../models/Account'
import { ObjectMappingsList } from '../shared/ObjectMappingsList'

interface CustomAdditionalObjectsAdminSettingsProps {
  serviceId: IntegrationServiceId
}

export const CustomAdditionalObjectsAdminSettings: React.FC<CustomAdditionalObjectsAdminSettingsProps> = ({ serviceId }) => {
  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)
  const { watch, setValue } = useFormContext<IntegrationSettings>()

  const additionalObjects = watch('mappings.additionalObjects') as DetailedCRMAccountIntegrationMapping[] | undefined

  const handleAddObject = () => {
    const newAdditionalObjects = additionalObjects
      ? [...additionalObjects, { objectName: null, mappingType: MappingType.CUSTOM, limit: DEFAULT_ADDITIONAL_OBJECTS_LIMIT }]
      : [{ objectName: null, mappingType: MappingType.CUSTOM }]
    setValue('mappings.additionalObjects', newAdditionalObjects)
  }

  return (
    <ObjectMappingsList
      items={additionalObjects ?? []}
      isLoading={isAccountFetching}
      getKey={(obj, index) => obj!.objectName + index}
      renderRow={(_, index) => <AdditionalObjectRow serviceId={serviceId} index={index} />}
      onAddObject={handleAddObject}
      addButtonLabel='+ Add object'
    />
  )
}
